/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from "jquery";
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import vSelect from "vue-select";
import InputMask from 'vue-input-mask';
import JsBarcode from "jsbarcode";
import Cropper from 'cropperjs';
import {BootstrapVue} from "bootstrap-vue";
import CreateEditBook from "./components/modals/CreateEditBook";
import ReaderInfo from "./components/modals/ReaderInfo";
import SearchForm from "./components/SearchForm";
import BookInfo from "./components/modals/BookInfo";
import ReservedBookInfo from "./components/modals/ReservedBookInfo";
import SearchReader from "./components/widgets/SearchReader";
import SearchBook from "./components/widgets/SearchBook";
import ExternalSearch from "./components/ExternalSearch/ExternalSearch";
import OwersBooks from "./components/widgets/OwersBooks";
import ReservedBooks from "./components/widgets/ReservedBooks";
import DescriptionReviews from "./components/widgets/DescriptionReviews";
import EventsLibrary from "./components/widgets/EventsLibrary";
import InHole from "./components/widgets/InHole";
import BooksInAcquisitionBatch from './components/AcquisitionBatch/BooksInAcquisitionBatch';
import BooksInTransfer from './components/Transfer/BooksInTransfer';
import BooksInInventory from './components/Reports/BooksInInventory';
import BooksInWriteOffSet from './components/WriteOffSet/BooksInWriteOffSet';
import store from './store';

import SettingsIndex from './components/Settings/Index'


//different apps
import Nk6ReportApp from './pages/reports/nk6';
import ChartsApp from './pages/reports/charts';
import GeneralApp from './pages/reports/general';

//font-awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faLink,
    faBookmark,
    faForward,
    faBackward,
    faPause,
    faStop,
    faPlay,
    faCheck,
    faMusic,
    faCaretUp,
    faCaretDown,
    faPlus,
} from '@fortawesome/free-solid-svg-icons';
import {
    faQuestionCircle
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


// Vue Draggable

import draggable from 'vuedraggable'


require("./bootstrap");
window.moment = require("moment");

Vue.use(VueRouter);
const router = new VueRouter(routes);

vSelect.props.components.default = () => ({
    OpenIndicator: {
        render: (createElement) =>
            createElement("i", {
                class: "mdi mdi-menu-down",
                style: "font-size:25px;",
            }),
    },
});

library.add(
    faLink,
    faBookmark,
    faForward,
    faBackward,
    faPause,
    faStop,
    faPlay,
    faPlus,
    faCheck,
    faMusic,
    faCaretUp,
    faCaretDown,
    faQuestionCircle
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component("v-select", vSelect);
Vue.component("jsbarcode", JsBarcode);
Vue.use(BootstrapVue);

Vue.component("book-info", BookInfo);
Vue.component("reserved-book-info", ReservedBookInfo);
Vue.component("reader-info", ReaderInfo);

Vue.component('settings-library', SettingsIndex);

Vue.component("external-search", ExternalSearch);
Vue.component('input-mask', InputMask);

export const eventBus = new Vue;

const MainLibraryApp = {
    el: "#library-app",
    router: router,
    store: store,
    components: {
        CreateEditBook,
        SearchForm,
        SearchReader,
        SearchBook,
        OwersBooks,
        ReservedBooks,
        DescriptionReviews,
        EventsLibrary,
        InHole,
        BooksInAcquisitionBatch,
        BooksInTransfer,
        BooksInInventory,
        BooksInWriteOffSet,
        draggable
    },
    data: {
        changePhone: false,
        searchquery: "",
        libraryId: $("#def-info").data("libraryid"),
        userId: $("#def-info").data("userid"),
        modal: null,
        searchresults: {
            reader: {
                fullname: null,
                address: null,
                code: null,
            },
            booksearched: {
                id: null,
                code: null,
                status_id: null,
                description: {
                    title: null,
                    author: null,
                    publication: null,
                },
            },
            reservedbook: {
                id: null,
                title: null,
            },
        },
        booksReport: [],
        readersReport: [],
        cities: [],
    },

    methods: {
        onSearchCity(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCity(loading, search, this);
            }
        },
        searchCity: _.debounce((loading, search, vm) => {
            fetch(
                `/cities/get?name=${search}`
            ).then(res => {
                res.json().then(json => (
                    vm.cities = json
                ));
                loading(false);
            });
        }, 350),
        setSelectedCity(value) {
            $('#city_id').val(value.id);
        },
        transferFrom: function (code) {
            axios
                .get("/library/search?sl=" + code)
                .then((response) => {
                    this.searchresults.booksearched = response.data;
                    window.location.href =
                        "/library/transfers/" +
                        this.searchresults.booksearched.transfers[0].id;
                })
                .catch(() => {
                });
        },

        sendSMS: function (resend = false) {
            let phone = null;
            phone = $("input[name=phone]").val();

            if ((this.changePhone && phone != "(000) 000-00-00") || resend) {
                $(".reader-sms").attr("hidden", false);
                $(".send-sms").attr("hidden", false);
                $("#readerForm").attr("onsubmit", "return false;");
                this.changePhone = false;
                axios
                    .post($(".send-sms").attr("href"), {
                        sendSMS: true,
                        phone: phone,
                    })
                    .then((result) => {
                        if (result.data.status === "success") {
                            $(".alert-danger ul").html("");
                            $(".reader-sms").attr("hidden", false);
                            $(".send-sms").attr("hidden", false);
                            console.log(result.data.sms_code);
                            $("#sms-code").val(result.data.sms_code);
                        } else {
                            $(".alert-danger ul").html("");
                            $.each(result.data.message, function (i, item) {
                                $(".alert-danger ul").append("<li>" + item + "</li>");
                            });
                        }
                    });
            } else {
                $("#readerForm").attr("onsubmit", "return true;");
                return false;
            }
        },

        searchInLibrary: function (searchInput = this.searchquery, modal) {
            let self = this;
            if (searchInput != "") {
                if (searchInput.substring(0, 1) == "2") {
                    this.searchReader(searchInput, modal);
                } else {
                    searchInput = searchInput.replace('#','%23');
                    axios
                        .get(
                            "/library/search?sl=" +
                            searchInput +
                            "&library=" +
                            this.libraryId
                        )
                        .then((response) => {
                            if (this.searchresults.reader.code != null) {
                                if (response.data.library_id == this.$root.libraryId && response.data.status_id != 4) {
                                    if (response.data.example_id == 1) {
                                        this.setStatusBook(
                                            response.data.id,
                                            this.searchresults.reader.id,
                                            2
                                        );
                                    } else {
                                        this.setStatusBook(
                                            response.data.id,
                                            this.searchresults.reader.id,
                                            3
                                        );
                                    }
                                }
                            } else {
                                this.$bvModal.show("bookInfo");
                                this.searchresults.booksearched = response.data;
                            }
                        })
                        .catch(() => {
                        });
                }
            }
        },

        searchReader: function (searchInput, modal) {
            let self = this;
            axios
                .get(
                    "/library/search?sl=" + searchInput + "&library=" + this.libraryId
                )
                .then((response) => {
                    self.modal = modal;
                    self.searchresults = response.data;
                    self.searchresults.booksearched = {
                        id: null,
                        code: null,
                        status_id: null,
                        description: {
                            title: null,
                            author: null,
                            publication: null,
                        },
                    };
                    this.$bvModal.show("readerInfo");
                })
                .catch(() => {
                });
        },

        giveBook: function (searchInput = this.searchquery, readerId, descriptionId = null) {
            let self = this;
            if (searchInput != "") {
                searchInput = searchInput.replace('#','%23');
                axios
                    .get(
                        "/library/give_book?code=" +
                        searchInput +
                        "&library_id=" +
                        this.libraryId +
                        "&reader_id=" +
                        readerId +
                        "&description_id=" +
                        descriptionId
                    )
                    .then((response) => {
                        if (this.searchresults.reader.code != null) {
                            if (response.data.library_id == this.$root.libraryId && response.data.id) {
                                if (response.data.has_reserved == 1) {
                                    this.$emit("delete_reserved_book");
                                }
                                if (response.data.example_id == 1) {
                                    this.setStatusBook(
                                        response.data.id,
                                        this.searchresults.reader.id,
                                        2
                                    );
                                } else {
                                    this.setStatusBook(
                                        response.data.id,
                                        this.searchresults.reader.id,
                                        3
                                    );
                                }
                            } else {
                                $(".invalid-feedback").show();
                                $(".invalid-feedback").html("<span>" + response.data + "</span>");
                                $(".invalid-feedback").fadeOut(4000);
                            }
                        }
                    })
                    .catch(() => {
                    });
            }
        },

        reservedBook: function (reservedBookId) {

            let self = this;
            axios
                .get(
                    "/library/reserved_books/" + reservedBookId
                )
                .then((response) => {
                    self.searchresults.reservedbook = response.data;
                    self.searchresults.reader = response.data.reader;
                    self.searchresults.booksearched = {
                        id: null,
                        code: null,
                        status_id: null,
                        description: {
                            title: null,
                            author: null,
                            publication: null,
                        },
                    };
                    this.$bvModal.show("reservedBookInfo");
                })
                .catch(() => {
                });
        },

        deleteReservedBook: function (reservedBookId) {
            let self = this;
            if (reservedBookId != "") {
                axios
                    .delete(
                        "/library/reserved_books/" + reservedBookId
                    )
                    .then((response) => {
                        self.searchresults.reservedbook = {
                            id: null,
                            title: null,
                        };
                        this.$emit("delete_reserved_book");
                        toastr.success("Бронювання видалено");
                    })
                    .catch(() => {
                    });
            }
        },

        printBarcode: function (bookId, init=false) {
            if (init) {
                JsBarcode(".barcode").init();
            }
            // let popupWinindow;
            // let innerContents = document.getElementById(bookId).outerHTML;
            // console.log(innerContents);
            // popupWinindow = window.open('', '_blank', 'width=1000,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            // popupWinindow.document.open();
            // popupWinindow.document.write('<html><head><style>@page {\n' +
            //     '   width: 685px;\n' +
            //     '   height: 355px;\n' +
            //     '    margin: 0px;\n' +
            //     '     /* change the margins as you want them to be. */\n' +
            //     '}</style></head><body onload="window.print()">' + innerContents + '</html>');
            // popupWinindow.document.close();
            // return;
            // let img = $(bookId)
            //     .find("svg")
            //     //.attr("src");
            let title = $(bookId).data("title");
            printJS({
                printable: bookId,
                type: "html",
                header: title,
                //headerStyle: "font-size:10px; height: 18px; overflow:hidden;",
                targetStyles: ['*'],
                css: "/css/barcode.css",
                scanStyles: false
            });
        },

        printBooksReport: function () {
            printJS({
                type: "html",
                printable: "books-report",
                header: "Звіт про додавання книг",
            });
        },

        printReadersReport: function () {
            printJS({
                type: "html",
                printable: "readers-report",
                header: "Звіт про додавання читачів",
            });
        },

        printProfile: function (htmlId) {

            let pdfUrl = $("#" + htmlId).data("pdf");

            printJS({
                type: "pdf",
                printable: pdfUrl,
                showModal: true,
            });
        },

        setStatusBook: function (book_id, reader_id, status_id) {
            let bookUp = {
                book_id: book_id,
                status_id: status_id,
                reader_id: reader_id,
                user_id: this.userId,
            };
            axios({
                method: "post",
                url: "/api/library/updatebook",
                data: bookUp,
            }).then((response) => {
                this.$refs.events.getStories(true);
                this.$bvModal.hide("reservedBookInfo");
                if (status_id != 1) {
                    this.searchReader(this.searchresults.reader.code);
                    toastr.success("Книга видана");
                } else {
                    this.$emit("back_book");
                    toastr.success("Книга повернута");
                }
            });
        },

        getBooksReport: function (start, end, userid, library_id) {
            if (!userid) {
                return;
            }
            let booksReport;
            axios
                .get(
                    "/api/library/books-report?start=" +
                    start +
                    "&end=" +
                    end, {
                        params: {
                            user_id: userid,
                            library: library_id
                        }
                    }
                )
                .then((response) => {
                    booksReport = response.data;
                    $('#sum').text(booksReport.sum);
                    $('#booksChart').remove(); // this is my <canvas> element
                    $('.card-body').append('<canvas id="booksChart"><canvas>');
                    let ctx = document.getElementById("booksChart").getContext("2d");
                    let chart = new Chart(ctx, {
                        // The type of chart we want to create
                        type: "bar",

                        // The data for our dataset
                        data: {
                            labels: response.data.labels,
                            datasets: [
                                {
                                    label: "Кількість доданих книжок",
                                    backgroundColor: "rgb(255, 99, 132)",
                                    borderColor: "rgb(255, 99, 132)",
                                    data: response.data.data,
                                },
                            ],
                        },

                        // Configuration options go here
                        options: {},
                    });
                });
        },

        getReadersReport: function (start, end, library_id) {
            axios
                .get(
                    "/api/library/readers-report?start=" +
                    start +
                    "&end=" +
                    end +
                    "&library=" +
                    library_id
                )
                .then((response) => {
                    this.readersReport = response.data;
                    $('#sum').text(this.readersReport.sum);
                    $('#readersChart').remove(); // this is my <canvas> element
                    $('.card-body').append('<canvas id="readersChart"><canvas>');
                    let ctx = document.getElementById("readersChart").getContext("2d");
                    let chart = new Chart(ctx, {
                        // The type of chart we want to create
                        type: "bar",

                        // The data for our dataset
                        data: {
                            labels: response.data.labels,
                            datasets: [
                                {
                                    label: "Кількість доданих читачів",
                                    backgroundColor: "rgb(255, 99, 132)",
                                    borderColor: "rgb(255, 99, 132)",
                                    data: response.data.data,
                                },
                            ],
                        },

                        // Configuration options go here
                        options: {},
                    });
                });
        },

        getBooksLibrariesReport: function (start, end) {
            axios
                .get(
                    "/api/library/books-libraries-report?start=" +
                    start +
                    "&end=" +
                    end +
                    "&library=" +
                    this.libraryId
                )
                .then((response) => {
                    let ctx = document.getElementById("booksChart").getContext("2d");
                    let chart = new Chart(ctx, {
                        // The type of chart we want to create
                        type: "bar",

                        // The data for our dataset
                        data: {
                            labels: response.data.labels,
                            datasets: response.data.libraries,
                        },

                        // Configuration options go here
                        options: {},
                    });
                });
        },

        startInternet(readerId) {
            axios
                .post("/library/start-internet", {
                    reader: readerId,
                })
                .then((response) => {
                    this.$refs.events.getStories(true);
                    $("#modal-reader").modal("hide");
                    this.$bvModal.hide("readerInfo");
                });
        },
    },
};

//handmade router for different apps
let AppClass;
const path = window.location.pathname;

switch (true) {
    case (path.indexOf('/library/reports/nk6/form') != -1):
        AppClass = Nk6ReportApp;
        break;

    case (path.indexOf('/library/reports/charts') != -1):
        AppClass = ChartsApp;
        break;

    case (path.indexOf('/library/reports/general') != -1):
        AppClass = GeneralApp;
        break;

    default:
        AppClass = MainLibraryApp;
}

const libraryApp = new Vue(AppClass);

JsBarcode(".barcode").init();

$(document).scannerDetection({
    timeBeforeScanTest: 200, // wait for the next character for upto 200ms
    avgTimeByChar: 40, // it's not a barcode if a character takes longer than 100ms
    endChar: [13],
    ignoreIfFocusOn: true,
    preventDefault: false, //this would prevent text appearing in the current input field as typed
    onComplete: scannerOnComplete,
});

function scannerOnComplete(barcode) {
    let pathname = $(location).attr("pathname");
    if (pathname.indexOf("/library/acquisition-batches") !== -1) {
        libraryApp.$refs.BooksInAcquisitionBatch.triggerInputFunction(barcode);

    } else if (pathname === "/library/transfers-from" ||
        pathname === "/library/transfers-to" ||
        pathname.indexOf("/library/transfers") !== -1
    ) {
        libraryApp.$refs.BooksInTransfer.triggerInputFunction(barcode);

    } else if (pathname === "/library/reports/inventory" ||
        pathname.indexOf("/library/reports/inventory") !== -1
    ) {
        libraryApp.$refs.BooksInInventory.triggerInputFunction(barcode);

    }else if (pathname.indexOf("/library/write-off-sets") !== -1) {
        libraryApp.$refs.BooksInWriteOffSet.triggerInputFunction(barcode);

    } else {
        $("input[name=code]").val(barcode);
        libraryApp.searchInLibrary(barcode);
    }
}

window.scannerOnComplete = scannerOnComplete;

$("#create-reader").submit(function (e) {
    
    return true; // remove this line if you want to enable sms verification (don't forget to run `npm run prod`)

    let data = new FormData($("#create-reader")[0]);
    if (
        $(location).attr("pathname") === "/library/new-reader" &&
        $("input[name=phone]").val() != "(000) 000-00-00"
    ) {
        $.ajax({
            url: $("#create-reader").attr("action"),
            type: "post",
            data: data, //$('#create-reader').serializeArray(),
            enctype: "multipart/form-data",
            processData: false, //Important!
            contentType: false,
            cache: false,
            success: function (result) {
                if (result.status === "success") {
                    $("#alert").attr("hidden", true);
                    $(".alert-danger ul").html("");

                    $("#create-reader").attr("action", result.html);
                    $(".reader-sms").attr("hidden", false);
                    $(".send-sms").attr("hidden", false);
                    $("#sms-code").val(result.sms_code);
                    $("input[name=_method]").attr("disabled", false);
                    $(".send-sms").attr(
                        "href",
                        $(".send-sms").attr("href") + "/" + result.id
                    );
                    history.pushState(null, null, result.htmlEdit);
                } else {
                    $("#alert").attr("hidden", false);
                    $(".alert-danger ul").html("");
                    $.each(result.message, function (i, item) {
                        $(".alert-danger ul").append("<li>" + item + "</li>");
                    });
                }
            },
        });
        return false;
    } else {
        // $(this).submit();
        return true;
    }
});
//

$("#sms").on("keyup", function (e) {
    $(this).attr("name", "sms");
    if ($("#sms-code").val() != $(this).val()) {
        $(this).addClass("is-invalid");
    } else {
        $(this).removeClass("is-invalid");
        $(this).addClass("is-valid");
        $(this).attr("name", "sms");
    }
});

$("#modal-reader").on("hide.bs.modal", function () {
    libraryApp.$data.searchresults = {
        reader: {
            fullname: null,
            address: null,
            code: null,
        },
        books: [],
        reserved_books: [],
        statuses: [],
        booksearched: {
            id: null,
            code: null,
            status_id: null,
            description: {
                title: null,
                author: null,
                publication: null,
            },
        },
    };
});

$(".search-box a, .search-box .app-search .srh-btn").on("click", function () {
    $(".app-search").toggle(200);
});
$(".deleteConfirmation").on("click", function () {
    if (confirm($(this).data("confirmation-message"))) return true;
    return false;
});

$("label.floating").click(function () {
    $(this)
        .parent()
        .find(".form-control")
        .focus();
});

$(document).on("change", "#filter-reader select[name=filter]", function () {
    $('input[name=filter]').val($(this).val());
    $("#filter-date").submit();
    $("#filter-reader").submit();
});
$(document).on("click", "#search-reader", function () {
    $("#sort-reader").submit();
});
$("input[name=s]").on("search", function () {
    $("#sort-reader").submit();
});
$("input[name=search]").on("search", function () {
    $("#sort-reader").submit();
});
$("#s").on("search", function () {
    $("#app-search").submit();
});


$("#languages").on("change", function () {
    $("input[name=search]").val($("#languages").val());
    // $("input[name=filter]").val($("#filter").val());
    $("#sort-reader").submit();
});

$("#rubric").on("change", function () {
    $("input[name=search]").val($("#rubric").val());
    // $("input[name=filter]").val($("#filter").val());
    $("#sort-reader").submit();
});

$(".dataTables_length #library_id").on("change", function () {
    $("input[name=library_id]").val($(this).val());
    $("#sort-reader").submit();
});

$(".dataTables_length #filter").on("change", function () {
    $("input[name=search]").val("");

    if ($(".dataTables_length #filter").val() === "additional_content") {
        window.location.href = "/library/books/search";
    } else if ($(".dataTables_length #filter").val() === "languages") {
        $('#languages').attr('hidden', false);
        $('#languages').attr('disabled', false);
        $('#rubric').attr('hidden', true);
        $('#rubric').attr('disabled', true);
        $('#search').hide();
        $("input[name=filter]").val($(this).val());
        $("input[name=search]").val($("#languages").val());
        $("#sort-reader").submit();
    } else if ($(".dataTables_length #filter").val() === "rubric") {
        $('#rubric').attr('hidden', false);
        $('#rubric').attr('disabled', false);
        $('#languages').attr('hidden', true);
        $('#languages').attr('disabled', true);
        $('#search').hide();
        $("input[name=filter]").val($(this).val());
        $("input[name=search]").val($("#rubric").val());
        $("#sort-reader").submit();
    } else {
        $('#languages').attr('hidden', true);
        $('#languages').attr('disabled', true);
        $('#rubric').attr('hidden', true);
        $('#rubric').attr('disabled', true);
        $('#search').attr('hidden', false);
        $("input[name=filter]").val($(this).val());
        // if($("#search").val() != ''){
        $("#sort-reader").submit();
        // }
    }

});

$(document).on("click", ".reader th", function () {
    if (typeof $(this).data("order") != "undefined") {
        $("input[name=order]").val($(this).data("order"));
        $("#sort-reader").submit();
        $("#search-books").submit();
    }
});

$(document).on("click", "#takePhoto", function () {
    $("#uploadApp")
        .parent()
        .fadeOut(200, function () {
            $("#cameraApp").fadeIn(200, function () {
                WebCam.init();
            });
        });
    return false;
});
$(document).on("click", "#takeUpload", function () {
    $("#cameraPhoto").val("");
    $("#snap")
        .removeAttr("src")
        .removeClass("visible");
    $("#cameraApp").fadeOut(200, function () {
        $("#uploadApp")
            .parent()
            .fadeIn(200);
    });
    return false;
});
$(".reader-avatar input.dropify, .rectangle-uploader input.dropify").dropify({
    messages: {
        default: "",
        // 'default': 'Перетягніть файл<br>або натиснить сюди',
        replace: "Перетягніть файл<br>або натиснить для зміни",
        remove: "Видалити",
        error: "Уууупс, щось пішло не так.",
    },
    error: {
        fileSize: "Перевищено максимальны розмір файла ({{ value }} макс).",
        minWidth: "Ширина зображення занадто мала ({{ value }}}px мін).",
        maxWidth: "Ширина зображення занадто велика ({{ value }}}px макс).",
        minHeight: "Висота зображення занадто мала ({{ value }}}px мін).",
        maxHeight: "Висота зображення занадто велика ({{ value }}px макс).",
        imageFormat: "Обраний тип файла не підтримується ({{ value }}).",
    },
    tpl: {
        wrap: '<div class="dropify-wrapper"></div>',
        loader: '<div class="dropify-loader"></div>',
        message:
            '<div class="dropify-message"><span class="mdi mdi-cloud-upload" /> <p class="text-center">{{ default }}</p></div>',
        preview:
            '<div class="dropify-preview" style="padding: 0px"><span class="dropify-render"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>',
        filename:
            '<p class="dropify-filename"><span class="file-icon"></span> <span class="dropify-filename-inner"></span></p>',
        clearButton:
            '<button type="button" class="dropify-clear">{{ remove }}</button>',
        errorLine: '<p class="dropify-error text-center">{{ error }}</p>',
        errorsContainer: '<div class="dropify-errors-container"><ul></ul></div>',
    },
});

let rangeSettings = {
    locale: {
        format: "DD.MM.YYYY",
        separator: "-",
        applyLabel: "Прийняти",
        cancelLabel: "Відмінити",
        fromLabel: "Від",
        toLabel: "До",
        customRangeLabel: "Custom",
        weekLabel: "W",
        daysOfWeek: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        monthNames: [
            "Січень",
            "Лютий",
            "Березень",
            "Квітень",
            "Травень",
            "Червень",
            "Липень",
            "Серпень",
            "Вересень",
            "Жовтень",
            "Листопад",
            "Грудень",
        ],
        firstDay: 1,
    },
    // startDate: moment($("input[name=dateFrom]").val())
    //   .startOf("day")
    //   .format("DD/MM/YYYY"),
    // endDate: moment($("input[name=dateTo]").val())
    //   .endOf("day")
    //   .format("DD/MM/YYYY"),
};

$(".range-books").daterangepicker(rangeSettings, function (start, end, label) {
    start = moment(start).format("YYYY-MM-DD");
    end = moment(end).format("YYYY-MM-DD");
    let userid = $('#user').val();
    let library_id = $('#library').val();
    libraryApp.getBooksReport(start, end, userid, library_id);
});
$(".report-books#user").change(function () {
    let start = moment($(".range-books").data('daterangepicker').startDate).format("YYYY-MM-DD");
    let end = moment($(".range-books").data('daterangepicker').endDate).format("YYYY-MM-DD");
    let userid = $('#user').val();
    let library_id = $('#library').val();
    libraryApp.getBooksReport(start, end, userid, library_id);
});

$(".report-books#library").change(function () {
    $('#user').val('');
    let start = moment($(".range-books").data('daterangepicker').startDate).format("YYYY-MM-DD");
    let end = moment($(".range-books").data('daterangepicker').endDate).format("YYYY-MM-DD");
    let userid = $('#user').val();
    let library_id = $('#library').val();

    let optgroups = $('#user').children();
    let parent_library_id = $(optgroups[0]).attr('data-library-id');

    $.each( optgroups, function(index) {
        if (library_id == parent_library_id) {
            $(this).show();
        } else {
            if ($(this).attr('data-library-id') == library_id) {
                $(this).show();
            } else {
                $(this).hide();
            }
        }
    });
    libraryApp.getBooksReport(start, end, userid, library_id);
});

$(".report-readers").change(function () {
    let start = moment($(".range-readers").data('daterangepicker').startDate).format("YYYY-MM-DD");
    let end = moment($(".range-readers").data('daterangepicker').endDate).format("YYYY-MM-DD");
    let library_id = $('.report-readers').val();
    libraryApp.getReadersReport(start, end, library_id);
});

$(".range-readers").daterangepicker(rangeSettings, function (start, end, label) {
    start = moment(start).format("YYYY-MM-DD");
    end = moment(end).format("YYYY-MM-DD");
    let library_id = $('.report-readers').val();
    libraryApp.getReadersReport(start, end, library_id);
});
$(".range-books-libraries").daterangepicker(rangeSettings, function (
    start,
    end,
    label
) {
    start = moment(start).format("YYYY-MM-DD");
    end = moment(end).format("YYYY-MM-DD");
    libraryApp.getBooksLibrariesReport(start, end);
});

$("#years").daterangepicker(
    {
        locale: {
            format: "YYYY",
        },
    },
    function (start, end, label) {
        start = moment(start).format("YYYY");
        end = moment(end).format("YYYY");
    }
);

let rangeReport = Object.assign({}, rangeSettings);
rangeReport.ranges = {
    "Перший квартал": [
        moment().startOf("year"),
        moment()
            .quarter(1)
            .endOf("quarter"),
    ],
    "Другий квартал": [
        moment()
            .quarter(2)
            .startOf("quarter"),
        moment()
            .quarter(2)
            .endOf("quarter"),
    ],
    "Третій квартал": [
        moment()
            .quarter(3)
            .startOf("quarter"),
        moment()
            .quarter(3)
            .endOf("quarter"),
    ],
    "Четвертий квартал": [
        moment()
            .quarter(4)
            .startOf("quarter"),
        moment()
            .quarter(4)
            .endOf("quarter"),
    ],
};
$(".range-report").daterangepicker(rangeReport);

$("[name=price]").mask("000 000 000 000 000 грн. 00 коп.", {reverse: true});
Inputmask().mask(document.getElementsByClassName("inputmask"));
//var myUpload = new FileUploadWithPreview('myUploader');

$("select#category").on("change", function (
    e,
    clickedIndex,
    newValue,
    oldValue
) {
    var selected = $(e.currentTarget).val();
    if (selected) {
        $("#udc_add").prop("disabled", true);
        $("input[name=title_udc]").prop("disabled", true);
    } else {
        $("#udc_add").prop("disabled", false);
        $("input[name=title_udc]").prop("disabled", false);
    }
});

let rangeReportStories = Object.assign({}, rangeSettings);
rangeReportStories.ranges = {
    Сьогодні: [
        moment().startOf("day"),
    ],
    Вчора: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Останні 7 днів": [moment().subtract(6, "days"), moment().endOf("day")],
    Місяць: [moment().subtract(1, "month"), moment().endOf("day")],
    Квартал: [moment().startOf("quarter"), moment().endOf("quarter")],
    Рік: [moment().subtract(1, "year"), moment().endOf("day")],
    "Теперешній місяць": [moment().startOf("month"), moment().endOf("day")],
    "Попередній місяць": [
        moment().subtract(1, "month"),
        moment().startOf("month"),
    ],
};
$("#stories").daterangepicker(rangeReportStories);

$("#stories").on("apply.daterangepicker", function (ev, picker) {
    $("input[name=dateFrom]").val(picker.startDate.format("YYYY-MM-DD"));
    $("input[name=dateTo]").val(picker.endDate.format("YYYY-MM-DD"));
    $("#filter-date").submit();
});

var WebCam = {
    video: document.querySelector("#camera-stream"),
    image: document.querySelector("#snap"),
    controls: document.querySelector("#cameraAppControls"),
    take_photo_btn: document.querySelector("#take-photo"),
    error_message: document.querySelector("#error-message"),
    inputImage: document.querySelector("#cameraPhoto"),

    init: function () {
        var $this = this;
        if ($this.video.hasAttribute("src") && $this.video.src) {
            $this.video.play();
            return true;
        }
        $this.take_photo_btn.addEventListener("click", function (e) {
            e.preventDefault();
            $this.takePhoto();
        });
        navigator.getMedia =
            navigator.getUserMedia ||

            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia;

        if (!navigator.getMedia) {
            $this.displayErrorMessage(
                "Your browser doesn't have support for the navigator.getUserMedia interface."
            );
        } else {
            navigator.getMedia(
                {
                    video: true,
                },
                function (stream) {
                    try {
                        $this.video.srcObject = stream;
                    } catch (error) {
                        $this.video.src = window.URL.createObjectURL(stream);
                    }
                    $this.video.play();
                    $this.video.onplay = function () {
                        $this.showVideo();
                    };
                },
                function (err) {
                    $this.displayErrorMessage(
                        "There was an error with accessing the camera stream: " + err.name,
                        err
                    );
                }
            );
        }
    },

    takePhoto: function () {
        var snap = this.takeSnapshot();
        this.image.setAttribute("src", snap);
        this.image.classList.add("visible");
        this.inputImage.value = snap;
        this.video.pause();
        $("#uploadApp").removeAttr("required");
    },

    showVideo: function () {
        this.hideUI();
        this.video.classList.add("visible");
        this.controls.classList.add("visible");
    },

    takeSnapshot: function () {
        var hidden_canvas = document.querySelector("#cameraCanvas"),
            context = hidden_canvas.getContext("2d");
        var width = this.video.videoWidth,
            height = this.video.videoHeight;
        if (width && height) {
            hidden_canvas.width = width;
            hidden_canvas.height = height;
            context.drawImage(this.video, 0, 0, width, height);
            return hidden_canvas.toDataURL("image/png");
        }
    },

    displayErrorMessage: function (error_msg, error) {
        error = error || "";
        if (error) {
            console.log(error);
        }
        this.error_message.innerText = error_msg;
        this.hideUI();
        this.error_message.classList.add("visible");
    },

    hideUI: function () {
        this.controls.classList.remove("visible");
        this.video.classList.remove("visible");
        this.image.classList.remove("visible");
        this.error_message.classList.remove("visible");
    },
};

//mixins
$('[data-toggle="tooltip"]').tooltip();
$("#newGivingReportSubmit").on("click", function () {
    var form = document.getElementById("newGivingReportForm");

    if (form.checkValidity()) {
        setTimeout(function () {
            window.location.reload();
        }, 1000);
    }
});

/* Game Questions Section */
$("#question_type_id").on("change", function () {
    if($(this).val() == 3) {
        $("#answers").show();
    } else {
        $("#answers").hide();
    }
});

$("#addRow").on("click", function () {

    $(".delRow").eq(0).show();

    var key = $("table.answers-list tr").length;
    var newRow = $("<tr>");
    var cols = "";
    cols += '<td><input type="text" class="form-control" name="answers[' + key + '][text]"/></td>';
    cols += '<td><input type="text" class="form-control" name="answers[' + key + '][points]" value="0"/></td>';
    cols += '<td>' +
        '<input type="hidden" name="answers[' + key + '][is_correct]" value="0">' +
        '<input type="checkbox" name="answers[' + key + '][is_correct]" value="1" class="form-control"/>' +
    '</td>';
    cols += '<td><input type="button" class="delRow btn btn-md btn-danger" value="Видалити"></td>';
    newRow.append(cols);
    $("table.answers-list").append(newRow);

});

$("table.answers-list").on("click", ".delRow", function (event) {
    if ($(".delRow").length == 2) {
        $(".delRow").eq(0).hide();
    }
    $(this).closest("tr").remove();
});
/* */

/* Bootstrap Nav-Tabs #hash Links */
$(function() {
    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"]').tab('show');

    $('.nav-tabs a').click(function (e) {
        $(this).tab('show');
        var scrollmem = $('body').scrollTop() || $('html').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });
});
/* */

/* Admin Alerts Fading Out */
$(function() {
    $(".alert").fadeOut(6000);
});
/* */

/* When modal is opened */
$('body').on('show.bs.modal', '.remove-item', function (event) {
    let link = $(event.relatedTarget);
    let href = link.attr('href');
    $(this).find('.modal-footer .btn-danger').attr('href', href);
});

/* cropper.js: Image Crop */
window.addEventListener('DOMContentLoaded', function () {
    var avatar = document.getElementById('avatar');
    var image = document.getElementById('image');
    var input = document.getElementById('input');
    var $progress = $('.progress');
    var $progressBar = $('.progress-bar');
    var $alert = $('.alert');
    var $modal = $('#modal');
    var cropper;

    if(!input) {
        return;
    }

    $('[data-toggle="tooltip"]').tooltip();

    input.addEventListener('change', function (e) {
        var files = e.target.files;
        var done = function (url) {
            input.value = '';
            image.src = url;
            $alert.hide();
            $modal.modal('show');
        };
        var reader;
        var file;
        var url;

        if (files && files.length > 0) {
            file = files[0];

            if (URL) {
                done(URL.createObjectURL(file));
            } else if (FileReader) {
                reader = new FileReader();
                reader.onload = function (e) {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    });

    $modal.on('shown.bs.modal', function () {
        cropper = new Cropper(image, {
            aspectRatio: 16 / 9,
            viewMode: 3,
        });
    }).on('hidden.bs.modal', function () {
        cropper.destroy();
        cropper = null;
    });

    document.getElementById('crop').addEventListener('click', function () {
        var initialAvatarURL;
        var canvas;

        $modal.modal('hide');

        if (cropper) {
            canvas = cropper.getCroppedCanvas({
                // width: 160,
                // height: 160,
            });
            initialAvatarURL = avatar.src;
            avatar.src = canvas.toDataURL();
            $progress.show();
            $alert.removeClass('alert-success alert-warning');

            canvas.toBlob(function (blob) {

                $("#content-form").find("button[type='submit']").attr('disabled', true);
                var segments = $(location).attr('href').split( '/' );
                var section = segments[4];
                var csrf = $('meta[name="csrf-token"]').attr('content');
                var formData = new FormData();

                formData.append('_token', csrf);
                formData.append('image', blob, 'avatar.jpg');

                $.ajax('/uploader/crop/' + section, {
                    method: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,

                    xhr: function () {
                        var xhr = new XMLHttpRequest();

                        xhr.upload.onprogress = function (e) {
                            var percent = '0';
                            var percentage = '0%';

                            if (e.lengthComputable) {
                                percent = Math.round((e.loaded / e.total) * 100);
                                percentage = percent + '%';
                                $progressBar.width(percentage).attr('aria-valuenow', percent).text(percentage);
                            }
                        };

                        return xhr;
                    },

                    success: function (data) {
                        if (data.image) {
                            $("#content-form").find("button[type='submit']").attr('disabled', false);
                            $("#content-form").append('<input type="hidden" name="image" value="' + data.image + '">');
                            //$alert.show().addClass('alert-success').text('Зображення завантажено успішно');
                        }
                    },

                    error: function () {
                        avatar.src = initialAvatarURL;
                        //$alert.show().addClass('alert-warning').text('Виникла помилка');
                    },

                    complete: function () {
                        $progress.hide();
                    },
                });
            });
        }
    });
});